export default [
  {
    path: 'medicaid',
    component: () => import('@/views/medicaid/MedicaidWrapper.vue'),
    children: [
      {
        path: '/medicaid/menu',
        name: 'medicaid',
        component: () => import('@/views/medicaid/Menu.vue'),
      },
      {
        path: '/medicaid/certification',
        name: 'medicaid-certification',
        component: () => import('@/views/medicaid/certification/Main.vue'),
      },
      {
        path: '/medicaid/claims',
        name: 'medicaid-claims',
        component: () => import('@/views/medicaid/claims/Main.vue'),
      },
      {
        path: '/medicaid/claims/batch/:id',
        name: 'medicaid-claims-batch',
        props: true,
        component: () => import('@/views/medicaid/batch/Main.vue'),
      },
    ],
  },
];
